export default __webpack_public_path__ + "static/media/card6.59c9ae02.jpg";